/**
 * Created with setting-lib codegen.
 */ import { featureToggle } from "@faire/web--source/common/settings/declarations/featureToggle";
/**
 * Controls whether full page prefetching of category links is enabled. Only works for treatment users of RSC
 * Category Pages XP (NEXTJS_RSC_SDUI_PRODUCT_FIRST_AND_HUB_CATEGORY_PAGE_241120)
 */ export var FE_ENABLE_CATEGORY_LINK_FULL_PAGE_PREFETCHING_250204 = featureToggle({
    name: "FE_ENABLE_CATEGORY_LINK_FULL_PAGE_PREFETCHING_250204",
    identifier: "RetailerTokenInSession",
    client: "RETAILER",
    notifyAfter: "2025-01-01",
    productArea: "RETAILER_PORTAL"
});
